module.exports = __webpack_public_path__ + "img/categories-8.02ecd126.jpg";